import { PortalUser as AjaxPortalUser } from '@client/components/ajax';
import { PortalUser, PortalUserRole } from './PortalUserList.types';

const isPortalUserRole = (value: number): value is PortalUserRole =>
  value === 1 || value === 2 || value === 3 || value === 4;

const toRole = (value: number): PortalUserRole =>
  isPortalUserRole(value) ? value : 2;

export const toPortalUser = (raw: AjaxPortalUser): PortalUser => ({
  id: raw.id,
  username: raw.username ?? '',
  role: toRole(raw.role),
  email: raw.email ?? '',
  firstName: raw.firstName ?? '',
  lastName: raw.lastName ?? '',
  isActive: Boolean(raw.isActive),
  influencerId: raw.influencerId ?? null,
});

export const toPortalUsers = (raw: AjaxPortalUser[]): PortalUser[] =>
  raw.map(toPortalUser);
